import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { Button } from '@upmc/ims.component-library';
const deleteModal = ({ isOpen, name, onAccept, onClose, onDismiss }) => {
	return (
		<Dialog open={isOpen} onClose={onClose}>
			<DialogTitle>Are you sure?</DialogTitle>
			<DialogContent>
				{name + ' will be deleted from your cart.'}
			</DialogContent>
			<DialogActions>
				<Button
					id={`app-remove-button__incomplete-dialog__cancel`}
					onClick={onDismiss}
					variant='text'
				>
					Cancel
				</Button>
				<Button
					autoFocus
					id={`app-remove-button__incomplete-dialog__accept`}
					onClick={onAccept}
					variant='text'
				>
					Remove
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default deleteModal;
